// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>34</span>&nbsp;&nbsp;He makes my feet like hinds&#146; feet&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;so that I tread surely on the heights.<br> </p> </div></div>";
// Exports
module.exports = code;